import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import classNames from 'classnames'

const SuccessMessage = () => {

  const [searchParams] = useSearchParams()
  const [hidden, setHidden] = useState(true)
  useEffect(() => {
    const success = searchParams.get('success')
    if (success) {
      setTimeout(() => setHidden(true), 5000)
      setHidden(false)
    }
  }, [])

  const defaultClasses = " rounded-md transition-all duration-300 absolute container-padding w-full bg-green-200 text-green-900 py-1 bg-opacity-60 backdrop-blur-md"
  
  return (
    <div className="container-padding">
      <div className="relative z-40">
        <div className={classNames(defaultClasses, {
          
          "-top-32 ": hidden,
          "top-1": !hidden 
        })}>
          <p className="text-center">Thank you for registering for the SelectFut 2023 Camp, looking forward to seeing you all there!</p>
        </div>
      </div>
    </div>
  )
}

export default SuccessMessage